import { render, staticRenderFns } from "./Modal-info-soste.vue?vue&type=template&id=01ac5059&scoped=true&lang=pug"
import script from "./Modal-info-soste.vue?vue&type=script&lang=js"
export * from "./Modal-info-soste.vue?vue&type=script&lang=js"
import style0 from "./Modal-info-soste.vue?vue&type=style&index=0&id=01ac5059&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ac5059",
  null
  
)

export default component.exports